import { isEmpty, isEqual } from "lodash";
import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import request from "./utils/request";
import moment from "moment";

export function fetchOrCreateRevenue(data, withoutLoader = false) {
    return async (dispatch) => {
        if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'wageFund', value: true });
        dispatch(resetError('wageFund'));
        try {
            const response = await request({ method: 'post', url: `${urls.revenues}/fetchOrCreate`, data });
            const { revenuesStaff, revenue } = response;
            dispatch({ type: 'SET_WAGE_FUND', field: 'revenue', data: revenue });
            dispatch({ type: 'SET_WAGE_FUND', field: 'revenuesStaff', data: revenuesStaff });
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'wageFund'));
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return {error};
        }
    }
}

export function fetchRevenue(id, withoutLoader = false) {
    return async (dispatch, getState) => {
        if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'wageFund', value: true });
        dispatch(resetError('wageFund'));
        try {
            const response = await request({ method: 'get', url: `${urls.revenues}/withStaff/${id}`, params: { withPlan: true, withRevenues: true }});
            const { revenuesStaff, revenue } = response;
            dispatch({ type: 'SET_WAGE_FUND', field: 'revenue', data: revenue });
            dispatch({ type: 'SET_WAGE_FUND', field: 'revenuesStaff', data: revenuesStaff });
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'wageFund'));
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return false;
        }
    }
}

export function fetchRevenues(params) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'wageFund', value: true });
        try {
            const response = await request({ method: 'get', url: urls.revenues, params });
            return response;
        } catch (error) {
            return {error: error};
        }
    }
}

export function updateRevenue(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'wageFund', value: true });
        dispatch(resetError('wageFund'));
        try {
            await request({ method: 'put', url: `${urls.revenues}/${data.id}`, data });
            dispatch({ type: 'SET_WAGE_FUND', field: 'revenue', data: null });
            dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return true;
        } catch (error) {
            dispatch(setError(error, 'wageFund'));
            dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return false;
        }
    }
}

export function createStaff(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'staff', value: true });
        dispatch(resetError('staff'));
        try {
            const response = await request({ method: 'post', url: `${urls.staff}`, data });
            dispatch({ type: 'ADD_WAGE_FUND', field: 'staff', data: response });
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'staff'));
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return {error};
        }
    }
}

export function fetchRevenueStaff(params) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'revenuestaff', value: true });
        dispatch(resetError('staff'));
        try {
            const response = await request({ method: 'get', url: `${urls.revenuesstaffs}`, params });
            dispatch({ type: 'SET_LOADER', field: 'revenuestaff', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'revenuestaff'));
            dispatch({ type: 'SET_LOADER', field: 'revenuestaff', value: false });
            return {error};
        }
    }
}

export function deleteStaff(id, withAfterData = false) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'staff', value: true });
        dispatch(resetError('staff'));
        try {
            const url = withAfterData ? `${urls.staff}/withAfterData/${id}` : `${urls.staff}/${id}`
            const response = await request({ method: 'delete', url });
            dispatch({ type: 'DELETE_WAGE_FUND', field: 'staff', id });
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'staff'));
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return {error};
        }
    }
}

export function fetchStaff(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'staff', value: true });
        dispatch(resetError('staff'));
        try {
            const response = await request({ method: 'get', url: `${urls.staff}/${id}` });
            dispatch({ type: 'SET_WAGE_FUND', field: 'detailStaff', data: response });
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'staff'));
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return false;
        }
    }
}

export function fetchStaffs(filters, withoutLoader = false, withoutCount = true, getAll = false) {
    return async (dispatch, getState) => {
        if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'staff', value: true });
        const filials = getState().handbook.filials;
        const user = getState().user.info;
        const paging = getState().wageFund.paging.staff;

        try {
            const params = { ...filters }

            if (!params.pointId) {
                if (filials.length > 0) {
                    params['pointId_in'] = filials.map(filial => filial.id);
                } else if (user.points.length > 0) {
                    const pointIds = user.points.map(item => item.id);
                    params['pointId_in'] = pointIds
                }
            }            

            if (!withoutCount) {
                const dataPatams = { ...params };
                const count = await request({ method: 'get', url: `${urls.staff}/count`, params: dataPatams });
                dispatch({ type: 'SET_WAGE_FUND_COUNT', field: 'staff', count });
            }

            if (!getAll) {
                params['_start'] = paging.start;
                params['_limit'] = paging.limit;
            } else {
                params['_start'] = 0;
                params['_limit'] = -1;
            }

            params['_sort'] = 'id:desc';

            const response = await request({ method: 'get', url: urls.staff, params });
            dispatch({ type: 'SET_WAGE_FUND', field: 'staff', data: response });
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return response;
        } catch (error) {
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return {error: error};
        }
    }
}

export function updateStaff(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'staff', value: true });
        dispatch(resetError('staff'));
        try {
            await request({ method: 'put', url: `${urls.staff}/${data.id}`, data });
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return true;
        } catch (error) {
            dispatch(setError(error, 'staff'));
            dispatch({ type: 'SET_LOADER', field: 'staff', value: false });
            return false;
        }
    }
}

export function fetchWageFundData(data) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'wageFund', value: true });
        dispatch(resetError('wageFund'));
        try {
            let staff;
            if (data.pointId) staff = await dispatch(fetchStaffs({ pointId: data.pointId }, true, true, true));
            if (!data.id) {
                const staffData = (staff || []).map((item) => ({id: item.id, name: item.name, postId: item.postId, lastRate: item.lastRate, lastPrizes: item.lastPrizes})).filter((item) => item);
                const revenue = await dispatch(fetchOrCreateRevenue({ ...data, staff: staffData, withPlan: true, withRevenues: true }, true));
                dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
                return revenue;
            } else {
                const revenue = await dispatch(fetchRevenue(data.id, true));
                dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
                return revenue;
            }
        } catch (error) {
            dispatch(setError(error, 'wageFund'));
            dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return false;
        }
    }
};

function getDiffRevenue(original, updated, user, date) {
    if (!original || !updated) return [];
    
    const originalRevenues = original.revenues || [];
    const updatedRevenues = updated.revenues || [];
    const revenuesChanges = [];

    for (let i = 0; i < originalRevenues.length; i++) {
      const originalItem = originalRevenues[i] || { sum: {} };
      const updatedItem = updatedRevenues[i] || { sum: {} };
  
      const originalSum = originalItem.sum || {};
      const updatedSum = updatedItem.sum || {};
  
      const itemChanges = [];

      const originalResult = originalSum.result || 'NaN';
      if (originalSum.plan !== updatedSum.plan) itemChanges.push({ index: i, date, field: 'plan', old: originalSum.plan, new: updatedSum.plan, type: originalSum.plan != null ? 'edit' : 'add',  user });
      if (originalResult !== updatedSum.result) itemChanges.push({ index: i, date, field: 'result', old: originalSum.result || originalSum.plan, new: updatedSum.result || 0, type: (originalSum.result != null || originalSum.plan != null) ? 'edit' : 'add', user });
      if (itemChanges.length > 0) revenuesChanges.push(itemChanges);
    }

    if (updated.revenueRatio != null) {
        if (original.revenueRatio) {
            if (original.revenueRatio !== updated.revenueRatio) revenuesChanges.push({ field: 'revenueRatio', type: 'edit', old: original.revenueRatio, new: updated.revenueRatio, date, user });
        } else {
            revenuesChanges.push({ field: 'revenueRatio', type: 'add', new: updated.revenueRatio, date, user });
        }
    }

    if (updated.normalShift != null) {
        if (original.normalShift) {
            if (original.normalShift !== updated.normalShift) revenuesChanges.push({ field: 'normalShift', type: 'edit', old: original.normalShift, new: updated.normalShift, date, user });
        } else {
            revenuesChanges.push({ field: 'normalShift', type: 'add', new: updated.normalShift, date, user });
        }
    }

    if (updated.percentsPosts != null) {
        if (original.percentsPosts) {
            if (!isEqual(original.percentsPosts, updated.percentsPosts)) revenuesChanges.push({ field: 'percentsPosts', type: 'edit', old: original.percentsPosts, new: updated.percentsPosts, date, user });
        } else {
            revenuesChanges.push({ field: 'percentsPosts', type: 'add', new: updated.percentsPosts, date, user });
        }
    }
  
    return (revenuesChanges && revenuesChanges.length > 0) ? revenuesChanges.flat() : [];
}

function getDiffRevenuesStaff(original, updated, user, date) {
    if (isEmpty(updated)) return null;

    const staffsChanges = [];

    if (!isEmpty(original)) {
        if (original.name !== updated.name) staffsChanges.push({ staffId: updated.staffId, type: 'edit', field: 'name', old: original.name, new: updated.name, date, user });
        
        if (original.firstRate !== updated.firstRate) staffsChanges.push({ staffId: updated.staffId, type: original.firstRate != null ? 'edit' : 'add', field: 'firstRate', old: original.firstRate, new: updated.firstRate, date, user });
        if (original.secondRate !== updated.secondRate) staffsChanges.push({ staffId: updated.staffId, type: (original.firstRate != null || original.secondRate != null) ? 'edit' : 'add', field: 'secondRate', old: original.secondRate || original.firstRate, new: updated.secondRate, date, user });    
        
        const originalPendingFirstRate = (original.pendingFirstRate || original.pendingFirstRate === 0) ? original.pendingFirstRate : null;
        const updatedPendingFirstRate = (updated.pendingFirstRate || updated.pendingFirstRate === 0) ? updated.pendingFirstRate : null;
        const originalPendingSecondRate = (original.pendingSecondRate || original.pendingSecondRate === 0) ? original.pendingSecondRate : null;
        const updatedPendingSecondRate = (updated.pendingSecondRate || updated.pendingSecondRate === 0) ? updated.pendingSecondRate : null;
        if (originalPendingFirstRate !== updatedPendingFirstRate) staffsChanges.push({ staffId: updated.staffId, type: originalPendingFirstRate !== null ? 'edit' : 'add', field: 'pendingFirstRate', old: original.pendingFirstRate, new: updated.pendingFirstRate, date, user });
        if (originalPendingSecondRate !== updatedPendingSecondRate) staffsChanges.push({ staffId: updated.staffId, type: (originalPendingFirstRate !== null || originalPendingSecondRate !== null) ? 'edit' : 'add', field: 'pendingSecondRate', old: original.pendingSecondRate || original.pendingFirstRate, new: updated.pendingSecondRate, date, user });    


        if (original.firstSumRevenuePrize !== updated.firstSumRevenuePrize) staffsChanges.push({ staffId: updated.staffId, type: original.firstSumRevenuePrize != null ? 'edit' : 'add', field: 'firstSumRevenuePrize', old: original.firstSumRevenuePrize, new: updated.firstSumRevenuePrize, date, user });
        if (original.secondSumRevenuePrize !== updated.secondSumRevenuePrize) staffsChanges.push({ staffId: updated.staffId, type: (original.firstSumRevenuePrize != null || original.secondSumRevenuePrize != null) ? 'edit' : 'add', field: 'secondSumRevenuePrize', old: original.secondSumRevenuePrize || original.firstSumRevenuePrize, new: updated.secondSumRevenuePrize, date, user });    

        if (original.firstPrizeRevenue !== updated.firstPrizeRevenue) staffsChanges.push({ staffId: updated.staffId, type: original.firstPrizeRevenue != null ? 'edit' : 'add', field: 'firstPrizeRevenue', old: original.firstPrizeRevenue, new: updated.firstPrizeRevenue, date, user });
        if (original.secondPrizeRevenue !== updated.secondPrizeRevenue) staffsChanges.push({ staffId: updated.staffId, type: (original.firstPrizeRevenue != null || original.secondPrizeRevenue != null) ? 'edit' : 'add', field: 'secondPrizeRevenue', old: original.secondPrizeRevenue || original.firstPrizeRevenue, new: updated.secondPrizeRevenue, date, user });    

        const originalRevenues = original.revenues || [];
        const updatedRevenues = updated.revenues || [];
    
        for (let i = 0; i < originalRevenues.length; i++) {
          const originalItem = originalRevenues[i] || { sum: {} };
          const updatedItem = updatedRevenues[i] || { sum: {} };
      
          const originalSum = originalItem.sum || {};
          const updatedSum = updatedItem.sum || {};
      
          const itemChanges = [];
    
          const originalResult = (originalSum.result || originalSum.result === 0) ? originalSum.result : null;
          const updatedResult = (updatedSum.result || updatedSum.result === 0) ? updatedSum.result : null;

          if (originalSum.plan !== updatedSum.plan) itemChanges.push({ staffId: updated.staffId, index: i, date, field: 'plan', old: originalSum.plan, new: updatedSum.plan, type: originalSum.plan != null ? 'edit' : 'add',  user });
          if (originalResult !== updatedResult) itemChanges.push({ staffId: updated.staffId, index: i, date, field: 'result', old: originalSum.result || originalSum.plan, new: updatedSum.result || 0, type: (originalSum.result != null || originalSum.plan != null) ? 'edit' : 'add', user });
          if (itemChanges.length > 0) staffsChanges.push(itemChanges);
        }

        const originalPrize = original.prize || [];
        const updatedPrize = updated.prize || [];

        for (let i = 0; i < updatedPrize.length; i++) {
            const originalItem = originalPrize[i] || null;
            const updatedItem = updatedPrize[i] || 0;
        
            const originalSum = originalItem ? originalItem.sum : null;
            const updatedSum = updatedItem.sum || 0;
        
            const itemChanges = [];
      
            if (!originalSum || originalSum !== updatedSum) itemChanges.push({ staffId: updated.staffId, index: i, date, datePrize: updatedItem.date, field: updatedItem.type ? updatedItem.type : 'prize', old: originalSum, new: updatedSum, type: originalSum != null ? 'edit' : 'add',  user });
            if (originalItem && originalItem.date !== updatedItem.date) itemChanges.push({ staffId: updated.staffId, index: i, date, oldDatePrize: originalItem.date, newDatePrize: updatedItem.date, field: updatedItem.type ? updatedItem.type : 'prize', type: 'edit',  user });
            if (updatedItem.isDeleted) itemChanges.push({ staffId: updated.staffId, index: i, date, datePrize: updatedItem.date, field: updatedItem.type ? updatedItem.type : 'prize', old: originalSum, new: updatedSum, type: 'delete',  user });
            if (updatedItem.isSend) itemChanges.push({ staffId: updated.staffId, index: i, date, datePrize: updatedItem.date, field: updatedItem.type ? updatedItem.type : 'prize', old: originalSum, new: updatedSum, type: 'send', sendTo: updatedItem.sendTo, user });
            if (updatedItem.isTake) itemChanges.push({ staffId: updated.staffId, index: i, date, datePrize: updatedItem.date, field: updatedItem.type ? updatedItem.type : 'prize', old: originalSum, new: updatedSum, type: 'take', user });
            if (itemChanges.length > 0) staffsChanges.push(itemChanges);
        }
    }
    
    if (updated.isRestored) {
        staffsChanges.push({ staffId: updated.staffId, type: 'restore', date, user });
        const updatedRevenues = updated.revenues || [];

        for (let i = 0; i < updatedRevenues.length; i++) {
            const updatedItem = updatedRevenues[i] || { sum: {} };

            const updatedSum = updatedItem.sum || {};
        
            const itemChanges = [];
    
            if (updatedSum.plan != null && updatedSum.plan !== 0) itemChanges.push({ staffId: updated.staffId, index: i, date, field: 'plan', new: updatedSum.plan, type: 'add',  user });
            if (updatedSum.result != null && updatedSum.result !== 0) itemChanges.push({ staffId: updated.staffId, index: i, date, field: 'result', new: updatedSum.result, type: 'add', user });
            if (itemChanges.length > 0) staffsChanges.push(itemChanges);
          }
    }

    return (staffsChanges && staffsChanges.length > 0) ? staffsChanges.flat() : null;
}

export function saveWageFundData(id, data, startOfMonthDate) {
    return async (dispatch, getState) => {
        if (!id || isEmpty(data)) return { error: { message: 'Нет данных для обновления' }};
        dispatch({ type: 'SET_LOADER', field: 'wageFund', value: true });
        dispatch(resetError('wageFund'));
        const initData = getState().wageFund.revenue;
        const staffData = getState().wageFund.revenuesStaff;
        const staff = getState().wageFund.staff;
        const user = getState().user.info;
        const { revenue, revenuesStaff } = data;

        const getStaffName = (item) => {
            if (!item) return;
            if (item.staffId) {
                const entity = staff.find((el) => el.id === item.staffId);
                if (entity) return entity.name;
            }
            return item.name;
        }

        try {
            const username = user.name ? user.name : user.username;
            const roleDescription = user.role && user.role.description ? user.role.description : ''
            const userText = `${roleDescription} ${username}`;
            const date = moment().format('DD.MM.YYYY HH:mm:ss');
            const revenueChanges = revenue.isChange ? getDiffRevenue(initData, revenue, userText, date) : [];

            const sendedData = { revenue: {}, updatedStaffData: [], };
            let send = {};

            if (revenueChanges && revenueChanges.length > 0) {
                sendedData.revenue = { ...revenue, changeLog: [...(revenue.changeLog || []), ...revenueChanges]};
                send.revenueData = true;
            }

            const updatedStaff = revenuesStaff.filter((item) => (item.isChange || item.isChangeData) && !item.isDeleted && !item.isDelete && !item.isNew);
            const deletedStaff = revenuesStaff.filter((item) => item.isDelete);
            const createdStaff = revenuesStaff.filter((item) => item.isNew);

            let sendedUpdatedStaffData = [];

            if (updatedStaff && updatedStaff.length > 0) {
                const updatedStaffData = updatedStaff.map((item) => {
                    const changeLog = item.changeLog || [];
                    const entityStaff = (staffData || []).find((el) => el.id === item.id);
                    const itemChanges = getDiffRevenuesStaff(entityStaff, item, userText, date);
                    if (itemChanges && itemChanges.length > 0) return {
                        ...item,
                        changeLog: [...changeLog, ...itemChanges],
                    }
                    return null;
                }).filter((item) => item);
                sendedUpdatedStaffData = updatedStaffData.map((item) => {
                    return {
                        ...item,
                        prize: (item.prize || []).filter((p) => !p.isDeleted && !p.isDelete && !p.isSend).map((p) => {
                            delete p.isTake;
                            return p;
                        }),
                    }
                });
                if (sendedUpdatedStaffData.length > 0) send.updatedStaffData = true;
            }

            if (deletedStaff && deletedStaff.length > 0) {
                deletedStaff.forEach((item) => {
                    revenueChanges.push({
                        field: 'staff',
                        type: 'delete',
                        id: item.staffId,
                        name: getStaffName(item),
                        date,
                        user: userText,
                    })
                });
                sendedData.revenue.changeLog = [...(revenue.changeLog || []), ...revenueChanges];
                send.revenueData = true;
            }

            const deletedStaffIds = (deletedStaff && deletedStaff.length > 0) ? deletedStaff.map((item) => item.id) : null;
            if (deletedStaffIds) send.deletedStaffIds = true;

            if (createdStaff && createdStaff.length > 0) {
                createdStaff.forEach((item) => {
                    const updatedRevenues = item.revenues || [];

                    for (let i = 0; i < updatedRevenues.length; i++) {
                        const updatedItem = updatedRevenues[i] || { sum: {} };

                        const updatedSum = updatedItem.sum || {};
                    
                        const itemChanges = [];
                
                        const changeLog = createdStaff.changeLog && createdStaff.changeLog.length > 0 ? createdStaff.changeLog : [];
                        if (updatedSum.plan != null && updatedSum.plan !== 0) changeLog.push({ index: i, date, field: 'plan', new: updatedSum.plan, type: 'add',  user });
                        if (updatedSum.result != null && updatedSum.result !== 0) changeLog.push({ index: i, date, field: 'result', new: updatedSum.result, type: 'add', user });
                        if (itemChanges.length > 0) changeLog.push(itemChanges);
                        createdStaff.changeLog = changeLog;
                    }

                    revenueChanges.push({
                        field: 'staff',
                        type: 'add',
                        id: item.staffId,
                        name: getStaffName(item),
                        date,
                        user: userText,
                    });
                });
                sendedData.revenue.changeLog = [...(revenue.changeLog || []), ...revenueChanges];
                sendedData.createdStaff = createdStaff;
                send.createdStaff = true;
                send.revenueData = true;
            }

            if (!isEmpty(send)) {
                if (send.revenueData) await request({ method: 'post', url: `${urls.revenues}/updateWageFund`, data: {id, startOfMonthDate, ...sendedData} });

                if (send.deletedStaffIds) {
                    await Promise.all(deletedStaffIds.map(async (id) => {
                        await request({ method: 'post', url: `${urls.revenuesstaffs}/deleteFromWageFund/${id}`, data: { startOfMonthDate } });
                        return true;
                    }))
                }

                if (send.createdStaff) {
                    await Promise.all(createdStaff.map(async (item) => {
                        await request({ method: 'post', url: `${urls.revenuesstaffs}/createFromWageFund`, data: item });
                        return true;
                    }))
                    const setdata = { revenue, revenuesStaff: revenuesStaff.map((item) => ({ ...item, isNew: false }))}
                    dispatch({ type: 'SET_WAGE_FUND', field: 'revenue', data: setdata });
                }

                if (send.updatedStaffData) {
                    await Promise.all(sendedUpdatedStaffData.map(async (item) => {
                        await request({ method: 'post', url: `${urls.revenuesstaffs}/updateFromWageFund`, data: { ...item, date } });
                        return true;
                    }))
                }
            }
            dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return true;
        } catch (error) {
            dispatch(setError(error, 'wageFund'));
            dispatch({ type: 'SET_LOADER', field: 'wageFund', value: false });
            return false;
        }
    }
}

export function autoCreateStaffData(staff, revenueId, startOfMonthDate) {
    return async () => {
        if (isEmpty(staff) || !revenueId || !startOfMonthDate) return [];

        try {
            const data = { staff, revenueId, startOfMonthDate};
            const result = await request({ method: 'post', url: `${urls.revenuesstaffs}/autoCreate`, data });
            return result;
        } catch (err) {
            console.error(err);
        }
    }
}

export function setWageFundPaging(field, paging) {
    return dispatch => {
        dispatch({ type: 'SET_WAGE_FUND_PAGING', field, paging });
    }
}